module.exports = __webpack_public_path__ + "media/images/games/dota-2/rectangle-7908f10acc506754bc92d492f02e36cc.jpg";